/* eslint-disable no-restricted-imports */
import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { ModalProgressBar } from '../../../../../../_metronic/_partials/controls';

export function UserEditDialogHeader({ id }) {

    const [title, setTitle] = useState('');
    // User Redux state
    const { userForEdit, actionsLoading } = useSelector(
        (state) => ({
            userForEdit: state.users.userForEdit,
            actionsLoading: state.channels.actionsLoading,
        }),
        shallowEqual,
    );

    useEffect(() => {
        let _title = id ? '' : 'New User';
        if (userForEdit && id) {
            _title = 'Edit User';
        }

        setTitle(_title);
        // eslint-disable-next-line
    }, [userForEdit, actionsLoading]);

    return (
        <>
            {actionsLoading && <ModalProgressBar variant="query" />}
            <Modal.Header closeButton>
                <Modal.Title id="modal-sizes-title-lg">{title}</Modal.Title>
            </Modal.Header>
        </>
    );
}
